import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

const RiskFreeIcon = () => {
  return (
    <span className="risk-free-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <g id="on_bg">
          <path
            className="cls-4"
            d="M37.16,48c5.99,0,10.84-4.85,10.84-10.84s-4.85-10.84-10.84-10.84H10.84c-5.99,0-10.84,4.85-10.84,10.84s4.85,10.84,10.84,10.84h26.32Z"
          />
        </g>
        <motion.g
          animate={{
            opacity: [1, 1, 1, 0, 0, 1, 1],
          }}
          transition={{
            ease: "easeInOut",
            times: [0, 0.05, 0.1, 0.2, 0.5, 0.6, 1],
            duration: 6,
            repeat: Infinity,
          }}
        >
          <g id="on_shape">
            <path
              className="cls-3"
              d="M27.87,44.13H10.84c-3.84,0-6.97-3.13-6.97-6.97s3.13-6.97,6.97-6.97h17.03v1.55H10.84c-2.99,0-5.42,2.43-5.42,5.42s2.43,5.42,5.42,5.42h17.03v1.55Z"
            />
          </g>
          <g id="on_o">
            <path
              className="cls-1"
              d="M16.26,41.03c-1.71,0-3.1-1.74-3.1-3.87s1.39-3.87,3.1-3.87,3.1,1.74,3.1,3.87-1.39,3.87-3.1,3.87ZM16.26,34.84c-.84,0-1.55,1.06-1.55,2.32s.71,2.32,1.55,2.32,1.55-1.06,1.55-2.32-.71-2.32-1.55-2.32Z"
            />
          </g>
          <g id="on_n">
            <path
              className="cls-1"
              d="M26.32,41.03c-.24,0-.47-.11-.62-.31l-3.25-4.34v3.87c0,.43-.35.77-.77.77s-.77-.35-.77-.77v-6.19c0-.33.21-.63.53-.73.32-.11.66,0,.86.27l3.25,4.34v-3.87c0-.43.35-.77.77-.77s.77.35.77.77v6.19c0,.33-.21.63-.53.73-.08.03-.16.04-.24.04Z"
            />
          </g>
        </motion.g>
        <g id="on_circle">
          <motion.circle
            className="cls-1"
            cx="37.16"
            cy="37.16"
            r="7.74"
            animate={{
              x: [0, 0, 0, -25.6, -25.6, 0, 0],
              scale: [1, 0.8, 1, 1, 1, 1, 1],
            }}
            transition={{
              ease: "easeInOut",
              times: [0, 0.05, 0.1, 0.3, 0.4, 0.6, 1],
              duration: 6,
              repeat: Infinity,
            }}
          />
        </g>
        <g id="off_bg">
          <path
            className="cls-4"
            d="M10.84,21.68C4.85,21.68,0,16.82,0,10.84S4.85,0,10.84,0h26.32c5.99,0,10.84,4.85,10.84,10.84s-4.85,10.84-10.84,10.84H10.84Z"
          />
        </g>
        <motion.g
          animate={{
            opacity: [1, 1, 1, 0, 0, 1, 1],
          }}
          transition={{
            ease: "easeInOut",
            times: [0, 0.05, 0.1, 0.2, 0.5, 0.6, 1],
            duration: 6,
            delay: 0.4,
            repeat: Infinity,
          }}
        >
          <g id="off_shape">
            <path
              className="cls-3"
              d="M37.16,17.81h-17.03v-1.55h17.03c2.99,0,5.42-2.43,5.42-5.42s-2.43-5.42-5.42-5.42h-17.03v-1.55h17.03c3.84,0,6.97,3.13,6.97,6.97s-3.13,6.97-6.97,6.97Z"
            />
          </g>
          <g id="off_o">
            <path
              className="cls-2"
              d="M24,14.71c-1.71,0-3.1-1.74-3.1-3.87s1.39-3.87,3.1-3.87,3.1,1.74,3.1,3.87-1.39,3.87-3.1,3.87ZM24,8.52c-.84,0-1.55,1.06-1.55,2.32s.71,2.32,1.55,2.32,1.55-1.06,1.55-2.32-.71-2.32-1.55-2.32Z"
            />
          </g>
          <g id="off_f_1">
            <polygon
              className="cls-2"
              points="30.19 8.52 30.19 10.06 31.74 10.06 31.74 11.61 30.19 11.61 30.19 13.94 28.65 13.94 28.65 6.97 32.52 6.97 32.52 8.52 30.19 8.52"
            />
          </g>
          <g id="off_f_2">
            <polygon
              className="cls-2"
              points="36.39 8.52 36.39 10.06 37.94 10.06 37.94 11.61 36.39 11.61 36.39 13.94 34.84 13.94 34.84 6.97 38.71 6.97 38.71 8.52 36.39 8.52"
            />
          </g>
        </motion.g>
        <g id="off_circle">
          <motion.circle
            className="cls-2"
            cx="10.84"
            cy="10.84"
            r="7.74"
            animate={{
              x: [0, 0, 0, 25.6, 25.6, 0, 0],
              scale: [1, 0.8, 1, 1, 1, 1, 1],
            }}
            transition={{
              ease: "easeInOut",
              times: [0, 0.05, 0.1, 0.3, 0.4, 0.6, 1],
              duration: 6,
              delay: 0.4,
              repeat: Infinity,
            }}
          />
        </g>
      </svg>
    </span>
  )
}

export default RiskFreeIcon
